import { IRewardFragment } from '@fhs-legacy/frontend/src/generated/graphql-gateway';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';

import RewardInUse from './redeemed-reward';
import RewardAvailable from './reward-available';

interface IRewardPointsBarProps {
  cartId: string;
  isRewardApplied: boolean;
  loyaltyRewardAvailable: IRewardFragment;
}

export default function RewardPointsBar({
  cartId,
  isRewardApplied,
  loyaltyRewardAvailable,
}: IRewardPointsBarProps) {
  const { selectedOffer, stagedCartPoints } = useAppSelector(state => ({
    selectedOffer: selectors.loyalty.selectSelectedOffer(state),
    stagedCartPoints: selectors.loyalty.selectStagedCartPoints(state),
  }));
  const hasSufficientBalance = stagedCartPoints >= loyaltyRewardAvailable?.pointCost;

  switch (true) {
    case !!selectedOffer:
      return null;
    case !hasSufficientBalance:
      return null;
    case isRewardApplied:
      return <RewardInUse cartId={cartId} loyaltyRewardAvailable={loyaltyRewardAvailable} />;
    default:
      return <RewardAvailable cartId={cartId} loyaltyRewardAvailable={loyaltyRewardAvailable} />;
  }
}
